import script from "./confirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./confirmModal.vue?vue&type=script&setup=true&lang=js"

import "./confirmModal.vue?vue&type=style&index=0&id=6c5ae0f8&lang=css"

const __exports__ = script;

export default __exports__